<template>
    <article class="image-result" :data-id="image.type + '-' + image.id">
      <div class="db db--outer">
      	<span @click="show">
	        <div class="aspect-ratio aspect-ratio--6x4">
	            <div v-lazyload class="image-result-img db contain aspect-ratio--object">
	           		<div class="image-placeholder">
					    <h6>{{image.image_id}}</h6>
					</div>
				    <img :data-url="image.iiif_root + '/full/400,/0/default.jpg'" class="image-result-img-item" @load="loaded = true" />
				    <template v-if="previewAnnotations && image.annotations.length > 0 && loaded">
				    	<div v-for="annotation in image.annotations" :key="annotation.id" class="region" :id="'annotation' + annotation.id" v-position="{origImageWidth: image.width, origImageHeight: image.height, annotation: annotation}" />
				    </template>
	            </div>
			</div>
	        <h3 class="image-title mt-3">{{image.image_id}}</h3>
			<h3 class="image-detail mt-1">
				<i class="fas fa-tags mr-1"></i>&nbsp;<span id="tags_count">{{image.tags.length}}</span>
				<i class="far fa-object-ungroup ml-2 mr-1"></i>&nbsp;<span id="annotations_count">{{image.annotations.length}}</span>
			</h3>
		</span>
		<div class="image-result__buttons" v-show="showToggle">
			<div class="button mark-toggle vtm-icon-M di" @click="toggleImage" :class="{'mark-toggle--active' : selectedImageIds.includes(image.id)}">
				<svg width="20px" height="15px" viewBox="0 0 20 15" version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink">
      				<desc>Star icon.</desc>
      				<defs></defs>
      				<g id="Star" stroke="none" stroke-width="1" fill="none"	fill-rule="evenodd">
  						<g id="SVGcode" transform="translate(-1.000000, -1.000000)">
							<polygon id="bounds" points="0 16 22 16 22 0 0 0"></polygon>
							<polygon id="Star" stroke="#222222"	stroke-linecap="square" fill-rule="nonzero"	points="5.24513796 14.5584124 11 11.4065927 16.754862 14.5584124 14.5382505 9.47723972 20.0243553 6.50010718 13.254288 6.51121061 11 1.26623262 8.74571196 6.51121061 1.97564469 6.50010718 7.46174947 9.47723972"></polygon>
  						</g>
      				</g>
      			</svg>
			</div>
		</div>
	  </div>
    </article>
</template>

<script>
import {mapGetters} from 'vuex'
import ImageModal from '../components/ImageModal'
import LazyLoadDirective from '../directives/LazyLoadDirective';
import AnnotationPositionDirective from '../directives/AnnotationPositionDirective';

export default {
	name: 'ImageResult',
	directives: {
		lazyload: LazyLoadDirective,
		position: AnnotationPositionDirective
	},
	props: ['image', 'showToggle'],
	data() {
		return {
			loaded: false
		}
	},
	computed: {
		...mapGetters([
			'selectedImageIds', 'previewAnnotations'
		])
	},
	methods: {
		show () {
			this.$store.dispatch('GET_IMAGE', {'id': this.image.id}).then((response) => {
				this.$modal.hideAll(); // To prevent from opening multiple modals
				this.$modal.show(ImageModal, {}, {width: '100%', height: '100%'});
			});
		},
		toggleImage() {
			if (this.selectedImageIds.includes(this.image.id)) {
				this.$store.commit('REMOVE_FROM_SELECTED_IMAGE_IDS', this.image.id);
			} else {
				this.$store.commit('ADD_TO_SELECTED_IMAGE_IDS', this.image.id);
			}
		}
	}
}
</script>